import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  IoPersonCircleOutline, 
  IoCalendarOutline, 
  IoMaleFemaleOutline, 
  IoCardOutline, 
  IoDocumentOutline, 
  IoMedicalOutline, 
  IoWomanOutline, 
  IoManOutline, 
  IoLocationOutline, 
  IoBusinessOutline, 
  IoMapOutline, 
  IoMailOutline, 
  IoCallOutline, 
  IoLogOutOutline,
  IoPersonOutline
} from 'react-icons/io5';

// Web Storage wrapper (using localStorage)
const storage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      //console.error('Error getting item from localStorage:', error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      //console.error('Error setting item in localStorage:', error);
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      //console.error('Error removing item from localStorage:', error);
    }
  },
  multiRemove: (keys) => {
    try {
      keys.forEach(key => localStorage.removeItem(key));
    } catch (error) {
      //console.error('Error removing multiple items from localStorage:', error);
    }
  }
};

// Styles
const styles = {
  mainContainer: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column',
  },
  scrollContainer: {
    flex: 1,
    padding: '16px',
    maxWidth: '800px',
    margin: '0 auto',
    width: '100%',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
    minHeight: '400px',
  },
  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #137a7f',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    marginTop: '16px',
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '24px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    borderWidth: '1px',
    borderColor: '#e0e0e0',
    borderStyle: 'solid',
    marginBottom: '20px',
  },
  profileHeader: {
    alignItems: 'center',
    marginBottom: '30px',
    paddingBottom: '24px',
    borderBottomWidth: '1px',
    borderBottomColor: '#f0f0f0',
    borderBottomStyle: 'solid',
  },
  avatarContainer: {
    marginBottom: '16px',
  },
  avatarIcon: {
    fontSize: '64px',
    color: '#137a7f',
  },
  profileName: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#137a7f',
    textAlign: 'center',
    marginBottom: '8px',
    margin: 0,
  },
  profileSubtitle: {
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
    marginBottom: '8px',
  },
  section: {
    marginBottom: '24px',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#137a7f',
    marginBottom: '16px',
    paddingBottom: '8px',
    borderBottomWidth: '1px',
    borderBottomColor: '#f0f0f0',
    borderBottomStyle: 'solid',
  },
  infoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  infoIcon: {
    marginTop: '2px',
    marginRight: '16px',
    fontSize: '20px',
    color: '#137a7f',
  },
  infoContent: {
    flex: 1,
  },
  label: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#999',
    marginBottom: '4px',
    textTransform: 'uppercase',
  },
  value: {
    fontSize: '16px',
    color: '#333',
    lineHeight: '22px',
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    backgroundColor: '#fff',
    borderRadius: '16px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  emptyIcon: {
    fontSize: '64px',
    color: '#ccc',
  },
  emptyText: {
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
    marginTop: '16px',
  },
  emptySubText: {
    fontSize: '14px',
    color: '#666',
    textAlign: 'center',
    marginTop: '8px',
  },
  logoutButton: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#e74c3c',
    borderRadius: '12px',
    padding: '16px',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '20px',
    cursor: 'pointer',
    border: 'none',
    width: '100%',
    transition: 'background-color 0.2s',
  },
  logoutButtonHover: {
    backgroundColor: '#c0392b',
  },
  logoutButtonText: {
    color: 'white',
    fontSize: '16px',
    fontWeight: '600',
    marginLeft: '10px',
  },
  spacer: {
    height: '20px',
  },
  navbar: {
    backgroundColor: '#137a7f',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  navbarTitle: {
    color: 'white',
    fontSize: '18px',
    fontWeight: '600',
    margin: 0,
  },
  backButton: {
    position: 'absolute',
    left: '20px',
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  backButtonText: {
    fontSize: '14px',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '15px',
    padding: '20px',
    width: '90%',
    maxWidth: '400px',
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#137a7f',
    marginBottom: '20px',
    textAlign: 'center',
  },
  modalButtons: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '20px',
  },
  modalButton: {
    padding: '10px 20px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
  },
  modalButtonCancel: {
    backgroundColor: '#f0f0f0',
    color: '#666',
  },
  modalButtonConfirm: {
    backgroundColor: '#e74c3c',
    color: 'white',
  },
};

// Add keyframes animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

// NavBar Component
const NavBar = ({ title, showBackButton = false }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.navbar}>
      {showBackButton && (
        <button
          onClick={() => navigate(-1)}
          style={styles.backButton}
        >
          ← <span style={styles.backButtonText}>Voltar</span>
        </button>
      )}
      <h1 style={styles.navbarTitle}>{title}</h1>
    </div>
  );
};

// Modal Component
const ConfirmModal = ({ visible, title, message, onConfirm, onCancel }) => {
  if (!visible) return null;

  return (
    <div style={styles.modalOverlay} onClick={onCancel}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.modalTitle}>{title}</h3>
        <p style={{ textAlign: 'center', marginBottom: '20px' }}>{message}</p>
        <div style={styles.modalButtons}>
          <button
            style={{ ...styles.modalButton, ...styles.modalButtonCancel }}
            onClick={onCancel}
          >
            Cancelar
          </button>
          <button
            style={{ ...styles.modalButton, ...styles.modalButtonConfirm }}
            onClick={onConfirm}
          >
            Sair
          </button>
        </div>
      </div>
    </div>
  );
};

// InfoItem Component
const InfoItem = ({ icon: IconComponent, label, value }) => {
  const safeValue = value || 'Não informado';
  
  return (
    <div style={styles.infoRow}>
      <div style={styles.infoIcon}>
        <IconComponent />
      </div>
      <div style={styles.infoContent}>
        <div style={styles.label}>{label}</div>
        <div style={styles.value}>{safeValue}</div>
      </div>
    </div>
  );
};

export default function DadosPacienteScreen() {
  const navigate = useNavigate();
  const [dadosPaciente, setDadosPaciente] = useState(null);
  const [dadosStorage, setDadosStorage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showExitModal, setShowExitModal] = useState(false);
  const [isHoveringLogout, setIsHoveringLogout] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Buscar dados da API (prioridade)
        const storedPesCod = storage.getItem('cpf');
        const storedLink = storage.getItem('storageLink') || storage.getItem('link');
        const storedChave = storage.getItem('chave');
        const storedGuid = storage.getItem('govbr_guid');
        const guidParam = storedGuid ? `&GUID=${storedGuid}` : '';

        // Verificar se temos link e chave para buscar dados da API
        if (!storedLink || !storedChave) {
          //console.log('Link ou chave não encontrados');
          setLoading(false);
          return;
        }

        // Buscar dados do localStorage
        const dadosStorageString = storage.getItem('dadosPaciente');
        if (dadosStorageString) {
          try {
            const parsedData = JSON.parse(dadosStorageString);
            setDadosStorage(parsedData && typeof parsedData === 'object' ? parsedData : {});
          } catch (error) {
            //console.log('Erro ao parsear dados do storage:', error);
            setDadosStorage({});
          }
        } else {
          setDadosStorage({});
        }

        // Buscar dados da API
        const url = `${storedLink}/apidadospaciente.rule?sys=SAU&p1=${storedChave}&p2=perfil&p10=${storedPesCod}${guidParam}`;
        //console.log('URL da API:', url);

        const response = await fetch(url);
        const data = await response.json();

        //console.log('Resposta da API:', data);

        if (data.status === 'success' && data.dados && Array.isArray(data.dados) && data.dados.length > 0) {
          const pacienteData = data.dados[0];
          setDadosPaciente(pacienteData && typeof pacienteData === 'object' ? pacienteData : {});
        } else {
          //console.log('API não retornou dados válidos');
          setDadosPaciente({});
        }
      } catch (error) {
        //console.log('Erro ao buscar dados:', error);
        setDadosPaciente({});
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formatarTelefone = (telefoneInput) => {
    try {
      if (!telefoneInput || telefoneInput === 'Não informado') return 'Não informado';
      
      const telefoneString = typeof telefoneInput === 'string' ? telefoneInput : String(telefoneInput);
      const digitos = telefoneString.replace(/\D/g, '');
      
      if (!digitos || digitos === '') return 'Não informado';
      
      const numeroSemDDI = digitos.startsWith('55') ? digitos.substring(2) : digitos;
      
      if (numeroSemDDI.length === 11) {
        const ddd = numeroSemDDI.substring(0, 2);
        const parte1 = numeroSemDDI.substring(2, 7);
        const parte2 = numeroSemDDI.substring(7);
        return `(${ddd}) ${parte1}-${parte2}`;
      }
      
      if (numeroSemDDI.length === 10) {
        const ddd = numeroSemDDI.substring(0, 2);
        const parte1 = numeroSemDDI.substring(2, 6);
        const parte2 = numeroSemDDI.substring(6);
        return `(${ddd}) ${parte1}-${parte2}`;
      }
      
      return digitos || 'Não informado';
    } catch (error) {
      //console.error('Erro ao formatar telefone:', error);
      return 'Não informado';
    }
  };

  const formatarCEP = (cepInput) => {
    try {
      if (!cepInput) return 'Não informado';
      
      let cepString = '';
      
      if (cepInput && typeof cepInput === 'object') {
        if (cepInput._j && typeof cepInput._j === 'string') {
          cepString = cepInput._j;
        } else {
          for (const key in cepInput) {
            if (typeof cepInput[key] === 'string' && /\d/.test(cepInput[key])) {
              cepString = cepInput[key];
              break;
            }
          }
          if (!cepString) {
            cepString = String(cepInput);
          }
        }
      } else if (typeof cepInput === 'string') {
        cepString = cepInput;
      } else if (typeof cepInput === 'number') {
        cepString = cepInput.toString();
      } else {
        cepString = String(cepInput);
      }
      
      const apenasNumeros = cepString.replace(/\D/g, '');
      
      if (apenasNumeros.length === 8) {
        return `${apenasNumeros.substring(0, 5)}-${apenasNumeros.substring(5)}`;
      }
      
      if (apenasNumeros.length > 0) {
        return apenasNumeros;
      }
      
      return 'Não informado';
    } catch (error) {
      //console.error('Erro ao formatar CEP:', error);
      return 'Não informado';
    }
  };

  const getDado = (campoApi, campoStorage, defaultValue = 'Não informado') => {
    try {
      let valor = null;

      if (dadosPaciente && typeof dadosPaciente === 'object' && dadosPaciente[campoApi] !== undefined && dadosPaciente[campoApi] !== null) {
        valor = dadosPaciente[campoApi];
      } else if (dadosStorage && typeof dadosStorage === 'object' && dadosStorage[campoStorage] !== undefined && dadosStorage[campoStorage] !== null) {
        valor = dadosStorage[campoStorage];
      }

      if (valor !== null && valor !== undefined && valor !== '') {
        if (campoApi === 'SEXO' || campoStorage === 'sexo') {
          return formatarSexo(String(valor));
        }
        return String(valor);
      }

      return defaultValue;
    } catch (error) {
      //console.error(`Erro ao obter dado ${campoApi}/${campoStorage}:`, error);
      return defaultValue;
    }
  };

  const hasAnyData = () => {
    if (dadosPaciente && typeof dadosPaciente === 'object' && Object.keys(dadosPaciente).length > 0) {
      return true;
    }
    if (dadosStorage && typeof dadosStorage === 'object' && Object.keys(dadosStorage).length > 0) {
      return true;
    }
    return false;
  };

  const formatarSexo = (sexo) => {
    if (!sexo) return 'Não informado';

    const sexoUpper = sexo.toUpperCase();
    switch (sexoUpper) {
      case 'M':
        return 'Masculino';
      case 'F':
        return 'Feminino';
      case 'I':
        return 'Indefinido';
      case 'O':
        return 'Outro';
      default:
        return sexo;
    }
  };

  const handleLogout = () => {
    setShowExitModal(true);
  };

  const confirmLogout = () => {
    setShowExitModal(false);
    try {
      storage.multiRemove(["cpf", "dadosPaciente"]);
      navigate("/");
    } catch (error) {
      //console.error("Erro ao fazer logout:", error);
    }
  };

  const cancelLogout = () => {
    setShowExitModal(false);
  };

  const renderDadosPaciente = () => {
    if (!hasAnyData()) {
      return (
        <div style={styles.emptyContainer}>
          <IoPersonOutline style={styles.emptyIcon} />
          <div style={styles.emptyText}>Cadastro não realizado</div>
          <div style={styles.emptySubText}>
            Procure a Unidade de Saúde mais próxima para habilitar.
          </div>
          <button
            style={{
              ...styles.logoutButton,
              ...(isHoveringLogout ? styles.logoutButtonHover : {}),
            }}
            onClick={handleLogout}
            onMouseEnter={() => setIsHoveringLogout(true)}
            onMouseLeave={() => setIsHoveringLogout(false)}
          >
            <IoLogOutOutline size={24} color="white" />
            <span style={styles.logoutButtonText}>Sair da Conta</span>
          </button>
        </div>
      );
    }

    return (
      <div style={styles.card}>
        <div style={styles.profileHeader}>
          <div style={styles.avatarContainer}>
            <IoPersonCircleOutline style={styles.avatarIcon} />
          </div>
          <h2 style={styles.profileName}>
            {getDado('NOME', 'nome', 'Usuário')}
          </h2>
          <div style={styles.profileSubtitle}>Dados Pessoais</div>
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Informações Pessoais</h3>
          <InfoItem
            icon={IoCalendarOutline}
            label="Data de Nascimento"
            value={getDado('DT_NASC', 'nascimento')}
          />
          <InfoItem
            icon={IoMaleFemaleOutline}
            label="Sexo"
            value={getDado('SEXO', 'sexo')}
          />
          <InfoItem
            icon={IoCardOutline}
            label="CPF"
            value={getDado('CPF', 'cpf')}
          />
          <InfoItem
            icon={IoDocumentOutline}
            label="RG"
            value={getDado('RG', 'rg')}
          />
          <InfoItem
            icon={IoMedicalOutline}
            label="CNS"
            value={getDado('CNS', 'cns')}
          />
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Filiação</h3>
          <InfoItem
            icon={IoWomanOutline}
            label="Mãe"
            value={getDado('MAE', 'mae')}
          />
          <InfoItem
            icon={IoManOutline}
            label="Pai"
            value={getDado('PAI', 'pai')}
          />
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Endereço</h3>
          <InfoItem
            icon={IoLocationOutline}
            label="Rua"
            value={getDado('RUA', 'logradouro')}
          />
          <InfoItem
            icon={IoBusinessOutline}
            label="Bairro"
            value={getDado('BAIRRO', 'bairro')}
          />
          <InfoItem
            icon={IoMapOutline}
            label="Cidade"
            value={getDado('CIDADE', 'municipio')}
          />
          <InfoItem
            icon={IoMailOutline}
            label="CEP"
            value={formatarCEP(getDado('CEP', 'cep'))}
          />
        </div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Contato</h3>
          <InfoItem
            icon={IoCallOutline}
            label="Celular"
            value={formatarTelefone(getDado('TEL', 'telefone'))}
          />
          <InfoItem
            icon={IoMailOutline}
            label="E-mail"
            value={getDado('EMAIL', 'email')}
          />
        </div>

        <button
          style={{
            ...styles.logoutButton,
            ...(isHoveringLogout ? styles.logoutButtonHover : {}),
          }}
          onClick={handleLogout}
          onMouseEnter={() => setIsHoveringLogout(true)}
          onMouseLeave={() => setIsHoveringLogout(false)}
        >
          <IoLogOutOutline size={24} color="white" />
          <span style={styles.logoutButtonText}>Sair da Conta</span>
        </button>

        <div style={styles.spacer} />
      </div>
    );
  };

  return (
    <div style={styles.mainContainer}>
      <NavBar title="Meu Perfil" showBackButton={true} />

      <div style={styles.scrollContainer}>
        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.loadingSpinner} />
            <div style={styles.loadingText}>Carregando dados...</div>
          </div>
        ) : (
          renderDadosPaciente()
        )}
      </div>

      <ConfirmModal
        visible={showExitModal}
        title="Sair"
        message="Deseja realmente sair da sua conta?"
        onConfirm={confirmLogout}
        onCancel={cancelLogout}
      />
    </div>
  );
}